export default {
  unit: 5,
  shape: {
    borderRadius: {
      small: '2px',
      medium: '3px',
      large: '6px'
    }
  },
  palette: {
    common: {
      white: 'hsl(0, 0%, 100%)',
      black: 'hsl(0, 0%, 0%)',
      violet: 'hsl(236, 63%, 66%)'
    },
    primary: {
      main: '#3281e2',
      contrastText: 'hsl(0, 0%, 100%)'
    },
    error: {
      main: 'hsl(5, 78%, 60%)',
      contrastText: 'hsl(0, 0%, 100%)'
    },
    warning: {
      main: 'hsl(40, 100%, 60%)',
      contrastText: 'hsl(0, 0%, 100%)'
    },
    success: {
      main: 'hsl(113, 38%, 59%)',
      contrastText: 'hsl(0, 0%, 100%)'
    },
    gray: {
      gray50: '#f7f7f7',
      gray100: '#f2f2f2',
      gray200: '#d1d1d1',
      gray300: '#c2c2c2',
      gray400: '#b2b2b2',
      gray900: '#626b7a'
    },
    text: {
      primary: '#000'
    }
  },
  typography: {
    fontFamily: '"Graphik LCG", sans-serif',
    h1: {
      fontSize: '36px',
      lineHeight: '51px',
      fontWeight: 600
    },
    h2: {
      fontSize: '30px',
      lineHeight: '42px',
      fontWeight: 600
    },
    h3: {
      fontSize: '24px',
      lineHeight: '34px',
      fontWeight: 600
    },
    h4: {
      fontSize: '20px',
      lineHeight: '28px',
      fontWeight: 500
    },
    h5: {
      fontSize: '18px',
      lineHeight: '25px',
      fontWeight: 500
    },
    h6: {
      fontSize: '16px',
      lineHeight: '22px',
      fontWeight: 500
    },
    body1: {
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: 400
    },
    body2: {
      fontSize: '13px',
      lineHeight: '18px',
      fontWeight: 400
    },
    action1: {
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: 500
    },
    action2: {
      fontSize: '13px',
      lineHeight: '18px',
      fontWeight: 500
    },
    body3: {
      fontSize: '12px',
      lineHeight: '16px',
      fontWeight: 400
    },
    action: {
      fontSize: '13px',
      lineHeight: '18px',
      fontWeight: 500,
      letterSpacing: '0.2px'
    }
  },
  transitions: {
    easing: {
      easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
      easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
      easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
      sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
    },
    duration: {
      shortest: 150,
      shorter: 200,
      short: 250,
      standard: 300,
      complex: 375,
      enteringScreen: 225,
      leavingScreen: 195
    }
  },
  zIndex: {
    appBar: 1000,
    popup: 2000,
    drawer: 3000,
    modal: 4000,
    toast: 5000,
    tooltip: 6000
  },
  shadow: {
    appBar: '0 4px 9px 0 rgba(0, 0, 0, 0.1)',
    popup: '0 7px 29px hsla(0, 0%, 0%, 0.3)',
    drawer: 'none',
    modal: 'none',
    toast: 'none',
    tooltip: 'none'
  },
  modals: {
    minWidth: 380,
    maxWidth: 530
  }
};